import React from "react"
import { Button as MaterialUIButton } from "@mui/material"

import { makeStyles } from "makeStyles"

type ButtonColor =
	| "default"
	| "primary"
	| "primaryOutlined"
	| "secondary"
	| "secondaryOutlined"
	| "link"
	| "link-no-underline"
	| "danger"

const useStyles = makeStyles()({
	default: {
		background: "#EDEFF0",
		color: "#505E5F",
		textTransform: "inherit",
		paddingLeft: 20,
		paddingRight: 20,
		border: "none",
		width: "100%",
		"&:hover": {
			background: "#EDEFF0",
			color: "#263739",
			border: "none",
		},
	},
	// Blue
	primary: {
		background: "#4691CE",
		color: "#F7F9FA",
		paddingLeft: 20,
		paddingRight: 20,
		textTransform: "inherit",
		border: "1px solid #4691CE",
		width: "100%",
		"&:hover": {
			background: "rgba(70, 145, 206, 0.07)",
			color: "#4691CE",
			border: "1px solid #4691CE",
		},
	},
	// Blue Outlined
	primaryOutlined: {
		background: "rgba(70, 145, 206, 0.07)",
		color: "#4691CE",
		paddingLeft: 20,
		paddingRight: 20,
		textTransform: "inherit",
		border: "1px solid #4691CE",
		width: "100%",
		"&:hover": {
			background: "#4691CE",
			border: "1px solid #4691CE",
			color: "#F7F9FA",
		},
	},
	// Black
	secondary: {
		background: "#263739",
		color: "#F7F9FA",
		paddingLeft: 20,
		paddingRight: 20,
		textTransform: "inherit",
		border: "1px solid #263739",
		width: "100%",
		"&:hover": {
			background: "rgba(70, 145, 206, 0.07)",
			color: "#263739",
			border: "1px solid #263739",
		},
	},
	// Black Outlined
	secondaryOutlined: {
		background: "rgba(70, 145, 206, 0.07)",
		color: "#263739",
		paddingLeft: 20,
		paddingRight: 20,
		textTransform: "inherit",
		border: "1px solid #263739",
		width: "100%",
		"&:hover": {
			background: "#263739",
			color: "#F7F9FA",
			border: "1px solid #263739",
		},
	},
	// Danger
	danger: {
		background: "#C3423F",
		color: "#F7F9FA",
		paddingLeft: 20,
		paddingRight: 20,
		textTransform: "inherit",
		border: "1px solid #C3423F",
		width: "100%",
		"&:hover": {
			background: "rgba(70, 145, 206, 0.07)",
			color: "#C3423F",
			border: "1px solid #C3423F",
		},
	},

	// link
	link: {
		background: "none",
		color: "#4691CE",
		textTransform: "inherit",
		textAlign: "left",
		textDecoration: "underline",
		textUnderlinePosition: "under",
		"&:hover": {
			background: "none",
			textDecoration: "underline",
		},
	},
	// link-no-underline
	linkNoUnderline: {
		background: "none",
		color: "black",
		textTransform: "inherit",
		textAlign: "left",
		textDecoration: "none",
		padding: 0,
		"&:hover": {
			background: "none",
			textDecoration: "none",
		},
	},
})

const getButtonClassName = (
	classes: {
		default: string
		primary: string
		primaryOutlined: string
		secondary: string
		secondaryOutlined: string
		danger: string
		link: string
		linkNoUnderline: string
	},
	color: ButtonColor,
) => {
	switch (color) {
		case "primary":
			return classes.primary
		case "primaryOutlined":
			return classes.primaryOutlined
		case "secondary":
			return classes.secondary
		case "secondaryOutlined":
			return classes.secondaryOutlined
		case "danger":
			return classes.danger
		case "link":
			return classes.link
		case "link-no-underline":
			return classes.linkNoUnderline
		default:
			return classes.default
	}
}
const Button = ({ color, type = "button", size, children, style, ...props }: Props) => {
	const { classes } = useStyles()
	const className = getButtonClassName(classes, color)

	return (
		<MaterialUIButton
			className={className}
			type={type}
			{...props}
			size={size}
			style={{ borderRadius: 21, fontSize: 16, fontFamily: "Mulish, sans-serif", ...style }}
		>
			{children}
		</MaterialUIButton>
	)
}

// TODO: types
interface Props {
	children: React.ReactNode
	color?: ButtonColor
	onClick?: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
	style?: React.CSSProperties
	type?: "button" | "submit" | "reset"
	disabled?: boolean
	disableRipple?: boolean
	tabIndex?: number
	className?: string
	size?: "small" | "medium" | "large"
}

export default Button
